import type { ListBuilderList } from '../../../types';

/**
 * Confirmed list - licenses with confirmed registry matches.
 *
 * Provides an audit trail view of all licenses that have been successfully
 * matched and confirmed by a compliance officer or auto-approved. Useful
 * for reviewing the matched population and spot-checking match quality.
 */
export const confirmedList: ListBuilderList = {
	id: 'default-licenses-confirmed',
	cacheTTL: 600000,
	name: 'Confirmed',
	type: 'default',
	active: true,
	sortOrder: 7,
	filterRules: {
		licenseMatchStatus: {
			defaultValue: [{ id: 'confirmed', label: 'Confirmed' }],
			locked: true,
			hidden: true,
		},
		licenseSalesRep: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			applyDefaultIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
		},
	},
	inheritsFrom: 'default-licenses-all',
};
